import qs from 'qs';
import LocalStorageManager from '@component_path/lib/localStorageManager';
import masterDataStore from '@component_path/lib/masterDataStore';

const CITY_CODE_API_PATH = '/api/v2/public/data/cities';

const getCities = (prefectureId, callback) => {
  const url = `${CITY_CODE_API_PATH}?${qs.stringify({ prefecture_id: prefectureId })}`;
  if (!LocalStorageManager.getStorage(url)) {
    // setMasterDateWithoutWorkerの中でcallbackが呼ばれる事になっているので、ここではコールしない
    masterDataStore.setMasterDataWithoutWorker(url, data => callback(data));
  } else {
    callback(LocalStorageManager.getStorage(url));
  }
};

export default getCities;